import React, { useState, useEffect } from 'react';
import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { useNotificationContext } from 'contexts/NotificationContextProvider';
import useChangeStep from 'hooks/useChangeStep';

import AccountError from '../../components/AccountError';
import useSubmitCreateTrial from '../../hooks/useSubmitCreateTrial';
import { FakeWrapper } from '../../layout';

import CreatingBusinessNumber from './CreatingBusinessNumber';

const LoadingState = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { createNewTrialNoCreditCard } = useSubmitCreateTrial();
  const changeStep = useChangeStep();
  const { hasValidLogin, hasValidName, accountExists } =
    useTrialsContext() || {};
  const { validateBusinessName, validateBusinessInfo } =
    useBusinessInfoContext() || {};
  const { shouldDisplay, setShouldDisplay } = useNotificationContext() || {};

  const handleSubmit = () => {
    const isValid = validateBusinessName(true);
    if (!isValid) return;

    setShouldDisplay(false);
    setIsSubmitting(true);
    if (!validateBusinessInfo('', false) && isValid) {
      createNewTrialNoCreditCard({ incompleteGmb: true }).then(() => {
        setIsSubmitting(false);
      });
    } else if (isValid) {
      createNewTrialNoCreditCard().then(() => {
        setIsSubmitting(false);
      });
    }
  };

  useEffect(() => {
    const validAccount = hasValidLogin();
    const validName = hasValidName();
    if (accountExists || !validAccount || !validName) {
      return changeStep('/trials', true);
    } else {
      handleSubmit();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FakeWrapper marginTop={-55} showIcon={false}>
      {shouldDisplay ? (
        <AccountError handleSubmit={handleSubmit} isSubmitting={isSubmitting} />
      ) : (
        <CreatingBusinessNumber />
      )}
    </FakeWrapper>
  );
};

export default LoadingState;
